import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Loader2 } from 'lucide-react';
import { Button } from './ui/button';
import { Input } from './ui/input';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const HelpConnectCertificateResend = ({ participantId, cert, defaultEmail, onCancel, onSent }) => {
  const [email, setEmail] = useState(defaultEmail || '');
  const [sending, setSending] = useState(false);

  const send = async (e) => {
    e.preventDefault();
    setSending(true);
    try {
      const res = await axios.post(`${API}/participants/${participantId}/helpconnect-certificates/${cert.id}/resend`, { email: email.trim() });
      toast.success(res.data.message);
      onSent();
    } catch (err) {
      const d = err.response?.data?.detail;
      toast.error(typeof d === 'string' ? d : 'Please enter a valid email address');
    } finally {
      setSending(false);
    }
  };

  return (
    <form onSubmit={send} className="flex items-center gap-2 px-3 pb-3" data-testid={`helpconnect-certificate-resend-form-${cert.id}`}>
      <Input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="participant@email.com"
        className="h-8 text-sm" autoFocus data-testid={`helpconnect-certificate-resend-email-${cert.id}`} />
      <Button type="submit" size="sm" disabled={sending || !email.trim()} data-testid={`helpconnect-certificate-resend-send-${cert.id}`}>
        {sending ? <Loader2 className="h-4 w-4 animate-spin" /> : 'Send'}
      </Button>
      <Button type="button" size="sm" variant="ghost" onClick={onCancel} data-testid={`helpconnect-certificate-resend-cancel-${cert.id}`}>Cancel</Button>
    </form>
  );
};
